// version 15/02
var rootLinkTikTokPixel = 'https://apps3.omegatheme.com/shopify/tiktok-multi-pixels/server.php';
var rootAppPublicTikTokPixel = 'https://apps3.omegatheme.com/shopify/tiktok-multi-pixels/public';
var shop = Shopify.shop;
var pageURL = null;
var checkStoreNewOmegaTikTok = null;
var CONTENT_TYPE_IS_PRODUCT_GROUP = 0;
var CONTENT_TYPE_IS_PRODUCT = 1;
// if (typeof __st.pageurl != 'undefined') {
//   pageURL = 'https://' + __st.pageurl;
// } else {
//   pageURL = window.location.href;
// }
pageURL = window.location.href;
// if (pageURL.indexOf('&')) {
//   pageURL = pageURL.split('&')[0];
// }
var EVENT_NAME_TOOL = {
  browse: 'Page View',
  viewContent: 'View Content',
  addToCart: 'Add to Cart',
  startCheckout: 'Initiate Checkout',
  purchase: 'Complete payment',
};
var user_agent = getUserAgent();
var pageReferrer = '';
var currency = Shopify.currency.active;
var cart_url = '//' + window.location.hostname + '/cart.json';
var itemInCart;
var otElementButtonAddToCart =
  ".gt_button-atc,#teeAtcButton,#new-form-atc,.ProductForm__AddToCart,.single_add_to_cart_button,#AddToCartForm button,.product__form button.add-to-cart, #AddToCart-product-template,.product-form__cart-submit,[name^='add']";
var otElementButtonCheckout =
  'form[action^="/checkout"] :submit[name^="checkout"],form[action^="/checkout"] .checkout-button,.checkout_btn,.OTCheckout,[name^="checkout"],form[action^="/cart"] :submit[name^="checkout"],form[action^="/cart"] .checkout-button,#cart .action_button.right .gt_checkout_button_main';
var ip = null;
var ot_ttclid = null;
var dayCheckNewStoreVersionAtcWebPixel = '2024-11-06';
var tik_tok_utm_parameter = otTikTokPixelDetectCampaign();
!(function (w, d, t) {
  w.TiktokAnalyticsObject = t;
  var ttq = (w[t] = w[t] || []);
  (ttq.methods = [
    'page',
    'track',
    'identify',
    'instances',
    'debug',
    'on',
    'off',
    'once',
    'ready',
    'alias',
    'group',
    'enableCookie',
    'disableCookie',
  ]),
    (ttq.setAndDefer = function (t, e) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    });
  for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
  (ttq.instance = function (t) {
    for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
      ttq.setAndDefer(e, ttq.methods[n]);
    return e;
  }),
    (ttq.load = function (e, n) {
      var i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      (ttq._i = ttq._i || {}),
        (ttq._i[e] = []),
        (ttq._i[e]._u = i),
        (ttq._t = ttq._t || {}),
        (ttq._t[e] = +new Date()),
        (ttq._o = ttq._o || {}),
        (ttq._o[e] = n || {});
      var o = document.createElement('script');
      (o.type = 'text/javascript'), (o.async = !0), (o.src = i + '?sdkid=' + e + '&lib=' + t);
      var a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(o, a);
    });
  ttq.checkOmega = function () {
    if (arguments.length > 0) {
      var oh, nh, ih, event_id;
      if (typeof arguments[0] == 'string') {
        oh = arguments[0];
      }
      if (typeof arguments[1] == 'string') {
        nh = arguments[1];
      }
      if (typeof arguments[2] == 'object') {
        ih = arguments[2];
      }
      if (typeof arguments[3] == 'string') {
        event_id = arguments[3];
        console.log('event_id: ' + event_id);
      } else if (typeof event_id == 'undefined') {
        let external_id = generateExternalID(36);
        event_id = getEventID(external_id);
        console.log('Create event_id: ' + event_id);
      }
      if (
        'string' == typeof oh &&
        '' != oh.replace(/\s+/gi, '') &&
        'string' == typeof nh &&
        nh.replace(/\s+/gi, '')
      ) {
        ttq.load(oh);
        ttq.page();
        switch (nh) {
          case 'StartCheckout':
            ttq.instance(oh).track('InitiateCheckout', ih, {
              event_id: event_id,
            });
            break;
          case 'Purchase':
            let user_information = null;
            try {
              user_information = JSON.parse(localStorage.getItem('user_information')) || {};
            } catch {
            }
            ttq.instance(oh).identify({
              email: user_information?.email,
              phone_number: user_information?.phone_number,
              external_id: user_information?.external_id,
            });
            ttq.instance(oh).track('CompletePayment', ih, {
              event_id: event_id,
            });
            break;
          case 'ViewContent':
          case 'Search':
          case 'AddToCart':
          case 'AddPaymentInfo':
          case 'Lead':
          case 'CompleteRegistration':
          case 'Checkout':
          case 'AddToWishlist':
            ttq.instance(oh).track(nh, ih, { event_id: event_id });
            break;
          default:
            return;
        }
      }
    }
  };

  //part2
})(window, document, 'ttq');

if (typeof $ == 'undefined') {
  console.log("1111")
  javascript: (function (e, s) {
    e.src = s;
    e.onload = function () {
      $ = jQuery.noConflict();
      if (typeof window.otCheckExistFileTikTokPixel === 'undefined') {
        if (!Shopify.Checkout) {
          otIncludeTrackTool();
        }
        otTikTokPixelInit($);
        ot_ttclid = otAddAttributeIDAds($);
        window.otCheckExistFileTikTokPixel = false;
      }
    };
    document.head.appendChild(e);
  })(
    document.createElement('script'),
    'https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js'
  );
} else {
  if (typeof window.otCheckExistFileTikTokPixel === 'undefined') {
    if (!Shopify.Checkout) {
      otIncludeTrackTool();
    }
    otTikTokPixelInit($);
    ot_ttclid = otAddAttributeIDAds($);
    window.otCheckExistFileTikTokPixel = false;
  }
}
async function otTikTokPixelInit($) {
  if (Shopify.Checkout && Shopify.Checkout.page.indexOf('thank_you') !== -1) {
    var checkTiktokPixelExpire = await otTikTokPixelCheckExpireApp($, rootLinkTikTokPixel, shop);
  } else {
    var checkTiktokPixelExpire = tikTokPixelCheckExpireApp;
  }
  if (!checkTiktokPixelExpire.check_expire && checkTiktokPixelExpire.enable_app) {
    await getIP().then((data) => {
      let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
      ip = data.match(ipRegex)[0];
    });
    otTikTokPixelCallCheckTime($)

    otMultiTikTokPixel(
      $,
      checkTiktokPixelExpire.content_type_event,
      typeof checkTiktokPixelExpire.enable_deduplication !== 'undefined'
        ? checkTiktokPixelExpire.enable_deduplication
        : 0
    );
  }
}

async function otMultiTikTokPixel($, content_type_event, enable_deduplication) {
  if (
    typeof arrayTikTokPixelTrackNew != 'undefined' &&
    typeof arrayTikTokPixelCapiTrackNew != 'undefined'
  ) {
    arrayTikTokPixelTrackNew.forEach(async function (element, index) {
      ttq.checkOmega(`${element}`, 'PageView');
    });
    //Detect type content_type
    let content_type = 'product_group';
    if (content_type_event == CONTENT_TYPE_IS_PRODUCT) {
      content_type = 'product';
    }
    //Detect type content_type

    if (arrayTikTokPixelCapiTrackNew.length > 0) {
      let external_id = generateExternalID(36);
      let event_id = getEventID(external_id);
      if (enable_deduplication == 1) {
        arrayTikTokPixelCapiTrackNew.forEach(async function (element, index) {
          ttq.checkOmega(`${element}`, 'PageView', event_id);
        });
      }
    }

    if (pageURL.indexOf('/products/') > -1) {
      // add event ViewContent
      if (pageURL.indexOf('?') > -1) {
        var product_url = pageURL.split('?');
        product_url = product_url[0] + '.json';
      } else {
        var product_url = pageURL + '.json';
      }
      var product = await otGetInfoProductByLink(product_url, $);
      if (product.title.indexOf("'") > -1) {
        product.title = product.title.replace(/'/g, '');
      }

      //Detect type content_type
      let content_id = typeof product.id !== 'undefined' ? product.id : meta.product.id;
      let variant_id = ot_getUrlParam('variant');
      if (content_type_event == CONTENT_TYPE_IS_PRODUCT) {
        content_id = variant_id !== null ? variant_id : meta.product.variants[0].id;
      }
      //Detect type content_type

      arrayTikTokPixelTrackNew.forEach(async function (element, index) {
        ttq.checkOmega(`${element}`, 'ViewContent', {
          content_id: `${content_id}`,
          content_type: content_type,
          value: otConvertPrice(product.variants[0].price),
          content_name: `${product.title}`,
          currency: `${currency}`,
        });
      });
      if (arrayTikTokPixelCapiTrackNew.length > 0) {
        let external_id = generateExternalID(36);
        let event_id = getEventID(external_id);
        trackEventsAPITikTok($, {
          action: 'ViewContent',
          event: 'ViewContent',
          eventShowTool: EVENT_NAME_TOOL.viewContent,
          event_id: event_id,
          url: pageURL,
          pixel_ids: arrayTikTokPixelCapiTrackNew,
          shop: Shopify.shop,
          ip: ip !== null ? ip : '',
          user_agent: user_agent,
          external_id: external_id,
          value: otConvertPrice(product.variants[0].price),
          content_name: `${product.title}`,
          currency: `${currency}`,
          content_id: `${content_id}`,
          content_type: content_type,
          ttclid: ot_ttclid,
        });
        if (enable_deduplication == 1) {
          arrayTikTokPixelCapiTrackNew.forEach(async function (element, index) {
            ttq.checkOmega(
              `${element}`,
              'ViewContent',
              {
                content_id: `${content_id}`,
                content_type: content_type,
                value: otConvertPrice(product.variants[0].price),
                content_name: `${product.title}`,
                currency: `${currency}`,
              },
              event_id
            );
          });
        }
      }
    }
  }
  if (Shopify.Checkout && Shopify.Checkout.page.indexOf('thank_you') !== -1) {
    let arrayContent = [];
    var productIds = [];
    Shopify.checkout.line_items.forEach(function (item, index) {
      if (item.variant_title != '') {
        var prod_name = item.title + ' - ' + item.variant_title;
      } else {
        var prod_name = item.title;
      }
      productIds.push(item.product_id);

      //Detect type content_type
      let content_type = 'product_group';
      let content_id = item.product_id;
      if (content_type_event == CONTENT_TYPE_IS_PRODUCT) {
        content_id = item.variant_id;
        content_type = 'product';
      }
      //Detect type content_type

      arrayContent.push({
        content_id: `${content_id}`,
        content_type: content_type,
        content_name: prod_name,
        quantity: item.quantity,
        price: otConvertPrice(item.price),
      });
    });

    addEventPurchaseInThankYouPageTikTok($, arrayContent, productIds, enable_deduplication);
  }
}

function getItemOnCartPage($, callback) {
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
  }).done((cart) => {
    if (typeof callback == 'function') {
      callback(cart);
    }
  });
}
async function otTikTokPixelCheckExpireApp($, rootLinkTikTokPixel, shop) {
  console.log($);
  'use strict';
  return new Promise((resolve) => {
    $.ajax({
      type: 'GET',
      data: { shop: shop },
      url: `${rootLinkTikTokPixel}/api/external/check-expire`,
      dataType: 'json',
    }).done((result) => {
      resolve(result.data);
    });
  });
}

async function addEventPurchaseInThankYouPageTikTok(
  $,
  arrayContent,
  productIds,
  enable_deduplication
) {
  const results = await getAllTikTokPixelInThankYouPage(productIds);
  if (typeof results['pixels'] !== 'undefined' && typeof results['pixelsCapi'] !== 'undefined') {
    window.arrayTikTokPixelCapiTrackNew = results['pixelsCapi'];
    window.arrayTikTokPixel = results['pixelCapi_information'];
    otIncludeTrackTool();
    var pixels = results['pixels'];
    var pixelsCapi = results['pixelsCapi'];
    if (pixels.length > 0) {
      pixels.forEach(async function (element, index) {
        ttq.checkOmega(`${element}`, 'Purchase', {
          contents: arrayContent,
          currency: `${currency}`,
          value: otConvertPrice(Shopify.checkout.subtotal_price),
        });
        if (shop == 'veralo-br.myshopify.com') {
          ttq.checkOmega(`${element}`, 'Checkout', {
            contents: arrayContent,
            currency: `${currency}`,
            value: otConvertPrice(Shopify.checkout.subtotal_price),
          });
        }
      });
    }
    if (pixelsCapi.length > 0) {
      let external_id = generateExternalID(36);
      let event_id = Shopify.checkout.order_id;
      getInformationCustomerHash(Shopify, external_id).then((user_infomartion) => {
        try {
          localStorage.setItem("user_information", JSON.stringify(user_infomartion));
        } catch {
        }
        trackEventsAPITikTok($, {
          action: 'Purchase',
          event: 'Purchase',
          eventShowTool: EVENT_NAME_TOOL.purchase,
          event_id: event_id,
          url: pageURL,
          pixel_ids: pixelsCapi,
          shop: Shopify.shop,
          ip: ip !== null ? ip : '',
          user_agent: user_agent,
          external_id: external_id,
          contents: arrayContent,
          currency: `${currency}`,
          value: otConvertPrice(Shopify.checkout.subtotal_price),
          user: user_infomartion,
          order_id: Shopify.checkout.order_id,
          ttclid: ot_ttclid,
        });
        if (enable_deduplication == 1) {
          pixelsCapi.forEach(async function (element, index) {
            ttq.checkOmega(
              `${element}`,
              'Purchase',
              {
                contents: arrayContent,
                currency: `${currency}`,
                value: otConvertPrice(Shopify.checkout.subtotal_price),
              },
              event_id.toString()
            );
          });
        }
      });
    }
  }
}
function getAllTikTokPixelInThankYouPage(productIDs) {
  return new Promise((resolve) => {
    $.ajax({
      type: 'GET',
      data: { product_ids: productIDs, shop: shop },
      url: `${rootLinkTikTokPixel}/api/external/pixels/purchase`,
      dataType: 'json',
    }).done((result) => {
      if (typeof result == 'string') {
        result = JSON.parse(result);
      }
      resolve(result.data);
    });
  });
}

function otGetInfoProductByLink(URL, $) {
  return new Promise((resolve) => {
    $.ajax({
      url: URL,
      dataType: 'jsonp',
      header: { 'Access-Control-Allow-Origin': '*' },
      success: function (responseData) {
        if (typeof responseData == 'string') {
          responseData = JSON.parse(responseData);
        }
        resolve(responseData.product);
      },
    });
  });
}
Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

function trackEventsAPITikTok($, data) {
  if (data.action !== 'Purchase') {
    $.ajax({
      url: `${rootLinkTikTokPixel}/api/external/events-api`,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data),
      keepalive: true,
    })
      .done((response) => {
        conditionShowTestTool($, data, response);
      })
      .fail((error) => {
        console.log(error);
      });
  } else {
    if (Shopify.shop == 'viralclothingworld.myshopify.com') {
      $.ajax({
        url: `${rootLinkTikTokPixel}/api/external/events-api`,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data),
        keepalive: true,
      })
        .done((response) => {
          conditionShowTestTool($, data, response);
        })
        .fail((error) => {
          console.log(error);
        });
    } else {
      conditionShowTestTool($, data, { code: 200 });
    }
  }
}

function conditionShowTestTool($, data, response) {
  if (
    sessionStorage.getItem('OT_TIKTOK_TRACK_TOOL_EVENT_API') == 'show' ||
    ot_getUrlParam('otEnableTrackTool') == '1'
  ) {
    data.pixel_ids.forEach((pixel) => {
      let time = new Date().getTime();
      let specific_dom = data.event + '-' + pixel + '-' + time;
      const objDomDetect = {
        domCardPixelTrack: '#ot-card-pixel-' + pixel,
        domTitlePixelTrack: '#ot-title-pixel-' + pixel,
        domAttributePixelTrack: 'ot-attribute-event-' + specific_dom,
        domInformationEventStatus: 'ot-information-event-status-' + specific_dom,
        domSvgLeft: 'ot-svg-left' + specific_dom,
        domSvgDown: 'ot-svg-down-' + specific_dom,
      };

      let checkToolAlreadyExists = setInterval(function () {
        if ($(objDomDetect.domCardPixelTrack).length) {
          otAppendEventInformation($, objDomDetect, response, data);
          clearInterval(checkToolAlreadyExists);
        }
      }, 100);
    });
  }
}

function getIP() {
  return fetch('https://www.cloudflare.com/cdn-cgi/trace').then((res) => res.text());
}

function generateExternalID(length) {
  var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
  var b = [];
  for (var i = 0; i < length; i++) {
    var j = (Math.random() * (a.length - 1)).toFixed(0);
    b[i] = a[j];
  }
  const externalID = localStorage.getItem('external_id_tik_tok_pixel');
  if (!externalID) {
    localStorage.setItem('external_id_tik_tok_pixel', b.join(''))
  }
  return externalID;
}

async function getInformationCustomerHash(Shopify, external_id) {
  let externalID = external_id;
  let email = Shopify.checkout.email == null ? null : await sha256(Shopify.checkout.email);
  let phone = null;

  if (Shopify.checkout.phone == null) {
    if (Shopify.checkout.billing_address.phone != null) {
      phone = await sha256(Shopify.checkout.billing_address.phone);
    } else if (Shopify.checkout.shipping_address.phone != null) {
      phone = await sha256(Shopify.checkout.shipping_address.phone);
    } else {
      phone = await sha256('')
    }
  } else {
    phone = await sha256(Shopify.checkout.phone);
  }

  let obj = {
    external_id: externalID,
    email: email,
    phone_number: phone,

  }

  return obj;
}
function getEventID(external_id) {
  return external_id + randomStringNumber();
}

function randomStringNumber() {
  let characters = '0123456789';
  let randstring = '';
  for (let i = 0; i < 10; i++) {
    randstring += characters[Math.floor(Math.random() * 9)];
  }
  return randstring;
}

async function sha256(message) {
  const msgBuffer = new TextEncoder('utf-8').encode(String(message).toLowerCase().trim());
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => ('00' + b.toString(16)).slice(-2)).join('');
}

function getUserAgent() {
  return window.navigator.userAgent;
}

function ot_getUrlParam(paramName) {
  var match = window.location.search.match('[?&]' + paramName + '(?:&|$|=([^&]*))');
  return match ? (match[1] ? match[1] : '') : null;
}

function otIncludeTrackTool() {
  //Check enable track tool
  let version = new Date().getTime();
  if (
    sessionStorage.getItem('OT_TIKTOK_TRACK_TOOL_EVENT_API') == 'show' ||
    ot_getUrlParam('otEnableTrackTool') == '1'
  ) {
    sessionStorage.setItem('OT_TIKTOK_TRACK_TOOL_EVENT_API', 'show');
    $.getScript(`${rootAppPublicTikTokPixel}/js/tiktok-track-tool.js?v=${version}`);
  }
}

function otAddAttributeIDAds($) {
  let ttclid_in_session = otGetCookie('ttclid');
  let ttclid_in_url = ot_getUrlParam('ttclid');
  let ttclid_in_local_storage = localStorage.getItem('ttclid');
  if (
    isJsonString(ttclid_in_local_storage) &&
    ttclid_in_local_storage != 'null' &&
    ttclid_in_local_storage != null
  ) {
    //delete if expire ttclid
    let oldDateTime = JSON.parse(ttclid_in_local_storage).time;
    let currentDateTime = new Date().getTime();
    if (otGetDayOfTime(oldDateTime, currentDateTime) >= 8) {
      window.localStorage.removeItem('ttclid');
    }
  }

  if (ttclid_in_url != null && ttclid_in_url != 'null') {
    //check in url
    otSetCookie('ttclid', ttclid_in_url, 6);
    window.localStorage.setItem(
      'ttclid',
      JSON.stringify({
        time: new Date().getTime(),
        ttclid: ttclid_in_url,
      })
    );
    otAddAttributeClickIdToOrder($, ttclid_in_url);
    return ttclid_in_url;
  } else if (ttclid_in_session != '') {
    //check in cookie
    otAddAttributeClickIdToOrder($, ttclid_in_session);
    return ttclid_in_session;
  } else if (
    ttclid_in_local_storage != 'null' &&
    ttclid_in_local_storage != null &&
    isJsonString(ttclid_in_local_storage)
  ) {
    //check in localStorage
    let temp_ttclid = JSON.parse(ttclid_in_local_storage).ttclid;
    otAddAttributeClickIdToOrder($, temp_ttclid);
    return temp_ttclid;
  } else {
    return null;
  }
}

function otAppendEventInformation($, objDomDetect, response, data) {
  $(objDomDetect.domCardPixelTrack).append(
    `<div>
        <div class = "ot-information-event-status" id = "${objDomDetect.domInformationEventStatus}">
          <div class = "ot-box-title-event-status">
            ${response.code == 200
      ? window.OT_SVG_TIKTOK.ot_svg_tick
      : window.OT_SVG_TIKTOK.ot_svg_error
    }
            <span class = "ot-title-event">${data.eventShowTool}</span>
          </div>
          <div style="padding: 13px 10px 0px 10px; display: block" id ="${objDomDetect.domSvgLeft}">
            ${window.OT_SVG_TIKTOK.ot_svg_arrow_left}
          </div>
          <div style="padding: 13px 10px 0px 10px; display: none" id ="${objDomDetect.domSvgDown}">
            ${window.OT_SVG_TIKTOK.ot_svg_arrow_down}
          </div>
          </div>
            <div class = "ot-attribute-event" id = "${objDomDetect.domAttributePixelTrack}">
            ${response.code !== 200 && response.message
      ? `
            <span style = "color: #8B8B8B;
            margin: 5px 0;">ERROR</span>
            <span><b>${response.message}</b></span>
            `
      : ` ${data.content_type && data.event !== 'Browse'
        ? `<span><b>content_type:</b> ${data.content_type}</span>`
        : ''
      }
                ${data.content_id ? `<span><b>content_id:</b> ${data.content_id}</span>` : ''}
                ${data.value ? `<span><b>value:</b>${data.value}</span>` : ''}
                ${data.content_name ? `<span><b>content_name:</b> ${data.content_type}</span>` : ''}
                ${data.currency ? `<span><b>currency: </b>${data.currency}</span>` : ''}
                ${data.contents
        ? `<span><b>contents:</b>${JSON.stringify(data.contents)}</span>`
        : ''
      }
                  <span><b>Page URL:</b> ${data.url}</span>`
    }

          </div>
    </div>`
  );
  $(objDomDetect.domTitlePixelTrack).css('border-bottom', '1px solid #e4e4e4');
  $('#' + objDomDetect.domInformationEventStatus).click(function () {
    if ($('#' + objDomDetect.domAttributePixelTrack).css('display') == 'none') {
      //Open detail attribute
      $('#' + objDomDetect.domAttributePixelTrack).css('display', 'flex');
      $('#' + objDomDetect.domSvgLeft).css('display', 'none');
      $('#' + objDomDetect.domSvgDown).css('display', 'block');
    } else {
      //Close detail attribute
      $('#' + objDomDetect.domAttributePixelTrack).css('display', 'none');
      $('#' + objDomDetect.domSvgLeft).css('display', 'block');
      $('#' + objDomDetect.domSvgDown).css('display', 'none');
    }
  });
}

function sendBrowserUrlLog($, rootLinkTikTokPixel, shop) {
  'use strict';
  return new Promise((resolve) => {
    $.ajax({
      type: 'GET',
      data: { shop: shop, url: window.location.href },
      url: `${rootLinkTikTokPixel}/api/external/browser-url-log`,
      dataType: 'json',
    }).done((result) => {
      resolve(result.data);
    });
  });
}

//Detect cookies
function otSetCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toGMTString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function otGetCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function otSaveUrlToMongo($, url, shop) {
  'use strict';
  getIP().then((data) => {
    let rootLinkFBPixelLog = 'https://apps2.omegatheme.com/shopify/facebook-pixel-event-log/api/';
    let ipRegex = /[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}/;
    let ip = data.split('ip=')[1].split('\n')[0];
    return new Promise((resolve) => {
      $.ajax({
        type: 'POST',
        data: {
          url: url,
          shop: shop,
          ip: ip,
          user_agent: window.navigator.userAgent,
        },
        url: `${rootLinkFBPixelLog}url-logs`,
        dataType: 'json',
      }).done((result) => {
        if (typeof result == 'string') {
          result = JSON.parse(result);
        }
        resolve(result);
      });
    });
  });
}

function otConvertPrice(number) {
  if (Number(number) % 1 !== 0) {
    return parseFloat(number).toFixed(2);
  } else {
    return number;
  }
}

function otGetDayOfTime(ms1, ms2) {
  return Math.ceil((ms2 - ms1) / (24 * 60 * 60 * 1000));
}

function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function otAddAttributeClickIdToOrder($, ttclid) {
  let conditionAddAttribute =
    Shopify.shop == 'paper-republic.myshopify.com' ||
    Shopify.shop == 'tiktok-multi-pixels.myshopify.com' ||
    Shopify.shop == 'paper-republic-uk.myshopify.com' ||
    Shopify.shop == 'paper-republic-fr.myshopify.com' ||
    Shopify.shop == 'paper-republic-de.myshopify.com' ||
    Shopify.shop == 'paper-republic-usa.myshopify.com' ||
    Shopify.shop == 'paper-republic-cz.myshopify.com';
  if (typeof ttclid !== 'undefined' && ttclid !== null && ttclid !== '' && conditionAddAttribute) {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        attributes: {
          ot_ttclid: ttclid,
        },
      },
    }).done((cart) => {
      console.log('Add ttclid: ' + ttclid);
    });
  }
}

function otAddExternalIDToOrder($, externalID) {
  if (typeof externalID !== 'undefined' && externalID !== null && externalID !== '') {
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: {
        attributes: {
          ot_external_id: externalID,
        },
      },
    });
  }
}

function generateEventID1(length) {
  var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789'.split('');
  var b = [];
  for (var i = 0; i < length; i++) {
    var j = (Math.random() * (a.length - 1)).toFixed(0);
    b[i] = a[j];
  }
  return b.join('');
}

function OtDetectAdsUrlTikTokPixel() {
  let isAdsUrl = false;
  const ARRAY_PARAMS_UTM = [
    "ttclid",
    "utm_source",
    "utm_campaign",
    "ad_group",
    "ad",
    "campaign_id",
    "ad_group_id",
    "ad_id",
  ];
  ARRAY_PARAMS_UTM.every((param) => {
    if (window.location.search.includes(param)) {
      isAdsUrl = true;
      return false;
    }
    return true;
  });
  return isAdsUrl;
}

function otSetCookieByAttributeWindowTikTokPixel(cname, cvalue) {
  const d = new Date();
  const exdays = otDetectAttributeWindowTikTokPixel();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function otDetectAttributeWindowTikTokPixel() {
  if (typeof tikTokPixelCheckExpireApp !== "undefined") {
    return Math.max(1, parseInt(7, 10) || 14);
  }
  return 14;
}

function otDetectUTMUrlTikTokPixel() {
  var utmInfo = {
    ttclid: otDetectFieldTikTokPixel('ttclid'),
    utm_source: otDetectFieldTikTokPixel("utm_source"),
    utm_campaign: otDetectFieldTikTokPixel("utm_campaign"),
    ad_group: otDetectFieldTikTokPixel("ad_group") || otDetectFieldTikTokPixel('utm_terms'),
    ad: otDetectFieldTikTokPixel("ad") || otDetectFieldTikTokPixel('utm_contents'),
    campaign_id: otDetectFieldTikTokPixel("campaign_id"),
    ad_group_id: otDetectFieldTikTokPixel("ad_group_id"),
    ad_id: otDetectFieldTikTokPixel("ad_id"),

  };

  return utmInfo;
}

function otGetCookieTikTokPixel(cname) {
  let name = cname + "=";
  let decodedCookie = document.cookie;
  decodedCookie = document.cookie;
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function otDetectUTMCookieTikTokPixel() {
  return {
    ttclid: otGetCookieTikTokPixel("ot_tik_tok_ttclid"),
    utm_source: otGetCookieTikTokPixel("ot_tik_tok_utm_source"),
    utm_campaign: otGetCookieTikTokPixel("ot_tik_tok_utm_campaign"),
    ad_group: otGetCookieTikTokPixel("ot_tik_tok_ad_group") || otGetCookieTikTokPixel('ot_tik_tok_utm_terms'),
    ad: otGetCookieTikTokPixel("ot_tik_tok_ad") || otGetCookieTikTokPixel('ot_tik_tok_utm_contents'),
    campaign_id: otGetCookieTikTokPixel("ot_tik_tok_campaign_id"),
    ad_group_id: otGetCookieTikTokPixel("ot_tik_tok_ad_group_id"),
    ad_id: otGetCookieTikTokPixel("ot_tik_tok_ad_id"),
  }
}

function otDetectFieldTikTokPixel(key_origin) {
  let value = ot_getUrlParam(key_origin);

  if (value != null && value != undefined) {
    otSetCookieByAttributeWindowTikTokPixel("ot_tik_tok_" + key_origin, value);
    return value;
  } else {
    otSetCookieByAttributeWindowTikTokPixel("ot_tik_tok_" + key_origin, '');
    return ''
  }
}


function otTikTokPixelDetectCampaign() {
  // check link come from ads
  const isComeFromAds = OtDetectAdsUrlTikTokPixel();

  return isComeFromAds ? otDetectUTMUrlTikTokPixel() : otDetectUTMCookieTikTokPixel();
}

function compareDates(dateToCompare, referenceDate) {
  if (!dateToCompare)
    return null;
  // ChuyÃ¡Â»Æ’n Ã„â€˜Ã¡Â»â€¢i chuÃ¡Â»â€”i ngÃƒ y thÃƒ nh Ã„â€˜Ã¡Â»â€˜i tÃ†Â°Ã¡Â»Â£ng Date
  const date1 = new Date(dateToCompare);
  const date2 = new Date(referenceDate);

  // So sÃƒÂ¡nh hai ngÃƒ y
  if (date1 < date2) {
    return 'old';
  } else {
    return 'new';
  }
}

async function otTikTokPixelCallCheckTime($) {
  console.log("Checking TikTok Pixel...");
  // if (!tikTokPixelCheckExpireApp) {
  //   var tikTokPixelCheckExpireApp = await otTikTokPixelCheckExpireApp($, rootLinkTikTokPixel, shop);
  // }
  // const responseApiCheckExpireApp = await otTikTokPixelCheckExpireApp($, rootLinkTikTokPixel, shop);
  const newCheckStoreNewOmegaTikTok = tikTokPixelCheckExpireApp?.last_install_date
    ? compareDates(tikTokPixelCheckExpireApp?.last_install_date, dayCheckNewStoreVersionAtcWebPixel)
    : 'old';


  if (checkStoreNewOmegaTikTok !== newCheckStoreNewOmegaTikTok) {
    checkStoreNewOmegaTikTok = newCheckStoreNewOmegaTikTok;
    console.log("checkStoreNewOmegaTikTok Ã„â€˜ÃƒÂ£ thay Ã„â€˜Ã¡Â»â€¢i: ", checkStoreNewOmegaTikTok);
    handleCheckStoreUpdate();
  }
}

//ATC
function handleCheckStoreUpdate() {
  // if (checkStoreNewOmegaTikTok == 'old') {
    setInterval(async function () {
      if (!ip) {
        await getIP().then((data) => {
          let ipRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;
          ip = data.match(ipRegex)[0];
        });
      }

      $.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'json',
      }).done((cart) => {
        localStorage.setItem('SAVE_CART', JSON.stringify(cart));
        let item_count = localStorage.getItem('OTPX');
        localStorage.setItem('OTPXADDED', 1);
        if (item_count != cart.item_count) {
          window.localStorage.setItem('OTPX', cart.item_count);
          if (cart.items.length > 0) {
            let lastItem = cart.items[0];
            let content_type = 'product_group';
            let content_id = lastItem['product_id'];
            if (typeof tikTokPixelCheckExpireApp != 'undefined') {
              if (tikTokPixelCheckExpireApp.content_type_event == CONTENT_TYPE_IS_PRODUCT) {
                content_type = 'product';
                content_id = lastItem['variant_id'];
              }
            }

            arrayTikTokPixelTrackNew.forEach(async function (element, index) {
              ttq.checkOmega(`${element}`, 'AddToCart', {
                content_id: `${content_id}`,
                content_type: content_type,
                value: parseInt(cart.total_price) / 100,
                content_name: `${lastItem['product_title']}`,
                currency: `${currency}`,
              });
            });
            if (arrayTikTokPixelCapiTrackNew.length > 0) {
              let external_id = generateExternalID(36);
              let event_id = getEventID(external_id);
              let referrerDocument = document.referrer;
              trackEventsAPITikTok($, {
                utm: tik_tok_utm_parameter?.ttclid ? tik_tok_utm_parameter : null,
                referrer: referrerDocument,
                action: 'AddToCart',
                event: 'AddToCart',
                eventShowTool: EVENT_NAME_TOOL.addToCart,
                event_id: event_id,
                url: pageURL,
                pixel_ids: arrayTikTokPixelCapiTrackNew,
                shop: Shopify.shop,
                ip: ip !== null ? ip : '',
                user_agent: user_agent,
                external_id: external_id,
                content_id: `${content_id}`,
                content_type: content_type,
                value: parseInt(cart.total_price) / 100,
                currency: `${currency}`,
                ttclid: otAddAttributeIDAds(),
                ip_source: ip ?? null,
                products: lastItem ? [lastItem] : null
              });
              if (tikTokPixelCheckExpireApp.enable_deduplication == 1) {
                arrayTikTokPixelCapiTrackNew.forEach(async function (element, index) {
                  ttq.checkOmega(
                    `${element}`,
                    'AddToCart',
                    {
                      content_id: `${content_id}`,
                      content_type: content_type,
                      value: parseInt(cart.total_price) / 100,
                      content_name: `${lastItem['product_title']}`,
                      currency: `${currency}`,
                    },
                    event_id
                  );
                });
              }
            }
          }
        }
        const externalID = generateExternalID(36);
        if (!cart.attributes.external_id || cart.attributes.external_id != externalID) {
          otAddExternalIDToOrder($, externalID)
        }
      });
    }, 5000);
  // }
}




localStorage.setItem('user_agent', getUserAgent());
localStorage.setItem('currency', Shopify.currency.active);
localStorage.setItem('arrayTikTokPixelCapiTrackNew', JSON.stringify(arrayTikTokPixelCapiTrackNew));
localStorage.setItem('arrayTikTokPixelTrackNew', JSON.stringify(arrayTikTokPixelTrackNew));
localStorage.setItem('shop', Shopify.shop);
localStorage.setItem('ttclid', JSON.stringify(otAddAttributeIDAds()));
localStorage.setItem('external_id', generateExternalID(36));
localStorage.setItem(
  'enable_deduplication',
  tikTokPixelCheckExpireApp.settings !== null
    ? tikTokPixelCheckExpireApp.settings.enable_deduplication
    : 0
);